export default class HeroVideo {
	constructor( heroWrapper = null ) {

		if ( ! heroWrapper ) return;

		this.heroWrapper = heroWrapper;
		this.heroVideo = this.heroWrapper.querySelector( '#hero-video');
		this.btnMute = this.heroWrapper.querySelector( '.js-video-controls .mute-control' ); //imageWrappers
		this.btnPause = this.heroWrapper.querySelector( '.js-video-controls .pause-control' );

		// this.init();
		this.events();
	}

	// init() {
	// 	this.heroVideo.muted = true;
	// 	if ( window.innerWidth < 768 )
	// 		this.btnPause.querySelector( '.icon' ).classList.add( 'stop' );
	// }

	events() {

		if ( window.innerWidth > 768 ) {
			this.btnMute.addEventListener( 'click', ev => {
				if ( this.heroVideo.muted === true ) {
					this.btnMute.querySelector( '.icon' ).classList.add('stop');
				} else {
					this.btnMute.querySelector( '.icon' ).classList.remove('stop');
				}
				this.heroVideo.muted = ! this.heroVideo.muted;
			});

			this.btnPause.addEventListener( 'click', ev => {
				if ( this.heroVideo.paused === true ) {
					this.heroVideo.play();
					this.btnPause.querySelector( '.icon' ).classList.remove('stop');
				} else {
					this.heroVideo.pause();
					this.btnPause.querySelector( '.icon' ).classList.add('stop');
				}
			});
		}
	}
}
